module.exports = __webpack_public_path__ + "img/bar-chart.97e956f0.png";